import colors from 'assets/theme/base/colors';

const { secondary } = colors;

const timelineConnector = {
  styleOverrides: {
    root: {
      backgroundColor: secondary.focus,
      borderColor: secondary.focus
    }
  }
};

export default timelineConnector;
